import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
var SubscribeButton = function (_a) {
    var tier = _a.tier, _b = _a.tier.tier, _c = _b === void 0 ? {} : _b, dollarPrice = _c.dollarPrice, isUserSubscribed = _c.isUserSubscribed, _d = _a.withPrice, withPrice = _d === void 0 ? false : _d, className = _a.className, onSubscribe = _a.onSubscribe;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var onClick = function () { return onSubscribe(tier); };
    var text = t('memberSubscriptions.subscribe');
    if (isUserSubscribed) {
        text = t('memberSubscriptions.subscribed');
    }
    else if (withPrice && dollarPrice) {
        text = t('memberSubscriptions.subscribeWithPrice', {
            dollarPrice: dollarPrice,
        });
    }
    var button = (React.createElement(BrandedButton, { className: className, size: "medium", variant: "brand-green", onClick: onClick, disabled: isUserSubscribed }, text));
    return isMobile ? (button) : (React.createElement(ActionBarItemWrapper, { tooltip: t('memberSubscriptions.subscribeToUnlock') }, button));
};
SubscribeButton.displayName = 'SubscribeButton';
export default SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map